<template>
    <div class="pin-input-v2">
        <label v-if="label">{{ label }}</label>
        <input
            v-model="currentPin"
            type="text"
            ref="pinInput"
            autocomplete="off"
            class="input-field"
            maxlength="4"
            @input="emit"
            @blur="blurInput">
        <div class="pins" @click="focusInput">
            <div class="pin-digit" :class="{active: isActive(0), 'has-value': hasValue(0)}">{{ currentPin[0] }}</div>
            <div class="pin-digit" :class="{active: isActive(1), 'has-value': hasValue(1)}">{{ currentPin[1] }}</div>
            <div class="pin-digit" :class="{active: isActive(2), 'has-value': hasValue(2)}">{{ currentPin[2] }}</div>
            <div class="pin-digit" :class="{active: isActive(3), 'has-value': hasValue(3)}">{{ currentPin[3] }}</div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            label: String,
            autofocus: Boolean,
            value: {
                required: true
            },
        },
        data() {
            return {
                inFocus: this.autofocus,
                currentPin: this.value || '',
            }
        },
        computed: {},
        watch: {
            value(pin) {
                this.currentPin = pin;
            }
        },
        methods: {
            focusInput() {
                this.inFocus = true;
                this.$refs.pinInput.focus();
            },
            blurInput() {
                this.inFocus = false;
            },
            isActive(idx) {
                return this.inFocus && (this.currentPin.length === idx || (this.currentPin.length === 4 && idx === 3));
            },
            hasValue(idx) {
                return this.currentPin.length > idx;
            },
            emit() {
                this.$emit('input', this.currentPin);
            },
        },
        mounted() {
            if (this.autofocus) {
                this.focusInput();
            }
        }
    }
</script>

<style lang="scss">
    .pin-input-v2 {
        display: block;

        label {
            color: #525f7f;
            font-size: 0.875rem;
            font-weight: 600;
        }

        .input-field {
            position: fixed;
            top: 200%;
            height: 1px;
        }

        .pins {
            display: flex;

            .pin-digit {
                position: relative;
                width: 46px;
                height: 46px;
                background-color: #fff;
                color: #8898aa;
                border: 1px solid #dee2e6;
                border-radius: 0.25rem;
                text-align: center;
                padding: 0.625rem 0.75rem;
                font-size: 0.875rem;
                transition: border-color 150ms ease-in-out;
                line-height: 24px;
                cursor: text;

                &:not(:last-child) {
                    margin-right: 7px;
                }

                &.active {
                    border-color: #5e72e4;
                    outline: 0;
                    box-shadow: 0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba(94, 114, 228, 0.1);

                    &:before {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translateY(-50%);
                        content: ' ';
                        border-left: 1px solid #9c9c9c;
                        width: 10px;
                        height: 20px;
                        animation: blink 1s step-end infinite;
                    }

                    &.has-value {
                        &:before {
                            left: calc(50% + 5px);
                        }
                    }
                }


            }
        }
    }

    @keyframes blink {
        50% {
            border-left: 1px solid transparent;
        }
    }
</style>
